var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonChartAverage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9377 13.5C10.9127 13.5 10.1083 11.151 9.33038 8.87963C8.59351 6.72638 7.83019 4.5 6.18769 4.5C5.80418 4.52255 5.43606 4.65876 5.13022 4.89126C4.82439 5.12377 4.59469 5.44205 4.47038 5.80556L3.40332 5.44725C3.43201 5.36288 4.11826 3.375 6.18769 3.375C8.63457 3.375 9.56944 6.10594 10.3952 8.51512C11.0753 10.5002 11.7171 12.375 12.9377 12.375C13.3212 12.3524 13.6893 12.2162 13.9952 11.9837C14.301 11.7512 14.5307 11.4329 14.655 11.0694L15.7215 11.4277C15.6934 11.5121 15.0071 13.5 12.9377 13.5Z",
    fill: "#00427D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.75V9.5625H3.375V8.4375H2.25V1.125H1.125V15.75C1.125 16.0484 1.24353 16.3345 1.4545 16.5455C1.66548 16.7565 1.95163 16.875 2.25 16.875H16.875V15.75H2.25Z",
    fill: "#00427D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.4375H5.625V9.5625H4.5V8.4375Z",
    fill: "#00427D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.4375H7.875V9.5625H6.75V8.4375Z",
    fill: "#00427D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.4375H12.375V9.5625H11.25V8.4375Z",
    fill: "#00427D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.4375H14.625V9.5625H13.5V8.4375Z",
    fill: "#00427D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.4375H16.875V9.5625H15.75V8.4375Z",
    fill: "#00427D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonChartAverage);
export default __webpack_public_path__ + "static/media/carbon_chart-average.64f65374a9315d9d4db4cb39fa941b64.svg";
export { ForwardRef as ReactComponent };